function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import IMask from 'imask';
import { format, parse } from 'fecha';
var optionMask = {
  mask: Date,
  lazy: false,
  pattern: 'd{/}`m{/}`Y',
  blocks: {
    d: {
      placeholderChar: 'D',
      mask: IMask.MaskedRange,
      from: 1,
      to: 31,
      maxLength: 2
    },
    m: {
      placeholderChar: 'M',
      mask: IMask.MaskedRange,
      from: 1,
      to: 12,
      maxLength: 2
    },
    Y: {
      placeholderChar: 'Y',
      mask: IMask.MaskedRange,
      from: 1900,
      to: 9999
    }
  },
  format: formatDate,
  parse: parseDate,
  autofix: true,
  overwrite: true
};
/**
 * Formatter date
 * @param {Date} date 
 * @returns {String} Return string formatted `DD/MM/YYYY` date string
 */

function formatDate(date) {
  if (date instanceof Date) return format(date, 'DD/MM/YYYY');
  return;
}
/**
 * Parsing Date
 * @param {String} date 
 * @returns {Date} Returns Date object. Returns null what date string is invalid or doesn't match format
 */


function parseDate(date) {
  return parse(date, 'DD/MM/YYYY');
}
/**
 * Create Custom Event
 * @param {Object} el element DOM
 * @param {String} eventName name of event
 * @param {Object} data element mask
 */


function fireEvent(el, eventName, data) {
  var e = document.createEvent('CustomEvent');
  e.initCustomEvent(eventName, true, true, data);
  el.dispatchEvent(e);
}
/**
 * Initial Masking
 * @param {Object} el element DOM
 * @param {Object} opts configuration options
 */


function initMask(el, opts) {
  return el.maskRef = IMask(el, _objectSpread(_objectSpread({}, optionMask), opts)).on('accept', () => fireEvent(el, 'accept', el.maskRef)).on('complete', () => fireEvent(el, 'complete', el.maskRef));
}
/**
 * Destroy Masking
 * @param {Object} el element DOM
 */


function destroyMask(el) {
  if (el !== null && el !== void 0 && el.maskRef) {
    el.maskRef.destroy();
    delete el.maskRef;
  }
}

export var imask = {
  initMask,
  destroyMask
};
export var fnDate = {
  parseDate,
  formatDate
};